import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="py-40 bg-[#0E1A2B] dark:bg-[#060d16] text-center transition-colors duration-300">
      <div className="max-w-[980px] mx-auto px-8">
        <h2 className="text-[64px] font-extralight leading-[1.1] tracking-[-0.015em] text-white mb-12">
          Turn Operational Complexity into Structured Intelligence
        </h2>
        <Link
          to="/solutions#audit"
          className="bg-white dark:bg-[#28D7C6] text-[#0E1A2B] h-[52px] px-8 rounded-full text-[17px] font-normal hover:bg-white/90 dark:hover:bg-[#20c4b5] transition-all whitespace-nowrap cursor-pointer inline-flex items-center"
        >
          Book Your Strategy Session
        </Link>
      </div>
    </section>
  );
}
